import { render, staticRenderFns } from "./custom-picture.vue?vue&type=template&id=37a6617c"
import script from "./custom-picture.vue?vue&type=script&lang=js"
export * from "./custom-picture.vue?vue&type=script&lang=js"
import style0 from "./custom-picture.vue?vue&type=style&index=0&id=37a6617c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports